export default __webpack_public_path__ + "static/media/jamun.29345ea3.png";